import React from 'react';
import './verify.scss';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

function Verify() {
    return (
        <div className="user-verify-alert">
            <div className="container">
                <Link to="/auth/register/identify">
                    <Button>Verify Account</Button>
                </Link>
                <p>In order to be able to place orders you must verify your account first.</p>
            </div>
        </div>
    );
}

export default Verify;
